import OGuideLabel from './o-guide-label';

export default OGuideLabel;